import PropTypes from 'prop-types';

export const PAGE_SIZES_PROP_TYPE = PropTypes.arrayOf(PropTypes.number);

export const HIGHLIGHTED_ITEMS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
);

export const DISABLED_ITEMS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
);
